import { setQueryStringCachingBehavior } from 'owa-querystring';
import isFeatureEnabled from './isFeatureEnabled';

/**
 * Configure querystring caching based on feature flag.
 * Call this after feature flags are initialized.
 * Inverting dependency to avoid circular dependency with "isFeatureEnabled" in owa-querystring
 */
export default function configureQueryStringCaching(): void {
    setQueryStringCachingBehavior(
        isFeatureEnabled(
            'fwk-removeQueryStringCache',
            undefined,
            true /*dontThrowIfNotInitialized*/
        )
    );
}
